import styled from 'styled-components';

export const StyledTables = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: fit-content;
  &::-webkit-scrollbar {
    display: none;
  }
`;
